/**
 * Created by olga on 28.01.2025
 */
TileGameTutorialHelper = {};

TileGameTutorialHelper.getImportantCards = function (conditions) {
    const importantCards = [];
    Game.currentGame.table.listOpen().forEach((card) => {
        if (conditions.some((condition) => card.isAppropriate(condition))) {
            importantCards.push(card.onGetView());
        }
    });

    return importantCards;
};

TileGameTutorialHelper.isApplicable = function (card, filter) {
    if (!filter) {
        return false;
    }

    for (let i = 0; i < filter.length; i++) {
        if (typeof filter[i] === "function") {
            if (card instanceof filter[i] || card.findComponent(filter[i])) {
                return true;
            }
        } else if (card.getRank() === filter[i]) {
            return true;
        }
    }

    return false;
};

TileGameTutorialHelper.createPlayCardStep = (data) => new TutorialStep({
    onStart: function () {
        const card = Game.currentGame.getCardForHint(data.hintCard || data);

        if (!card) {
            cleverapps.tutorial.on("shiftCard", this.finish.bind(this), this);
            if (data.amountExtraCards) {
                Game.currentGame.hand.addExtra(data.amountExtraCards, {});
                Game.currentGame.hand.extra.setEnable(true);
            }
            return;
        }

        this.force = TileGameTutorialHelper.createForce(card.onGetView(), data);

        cleverapps.tutorial.on("playCard", this.finish.bind(this), this);
    },
    onFinish: function () {
        this.force.hideForceHints();
    }
});

TileGameTutorialHelper.createForce = (target, data) => {
    const tileGameComponent = cleverapps.Scenes.GetSceneComponent(TileGameSceneComponent);
    const openCards = Game.currentGame.table.listOpen()
        .filter((openCard) => TileGameTutorialHelper.isApplicable(openCard, data.filter), this)
        .map((card) => card.onGetView());
    const importantNodes = openCards.filter((cardView) => cardView !== target && (data.importantCards || [])
        .some((ClassName) => cardView.card instanceof ClassName || cardView.card.findComponent(ClassName)));

    const allCards = Game.currentGame.table.cards.map((card) => card.onGetView());
    const highlights = allCards.filter((cardView) => cardView !== target);

    const openCardsControl = tileGameComponent.leaf && tileGameComponent.leaf.openCardsControl;
    if (openCardsControl) {
        highlights.push(openCardsControl);
        importantNodes.push(openCardsControl);
    }
    highlights.push(cleverapps.Scenes.GetMovingNode());

    return cleverapps.forces.create(target, {
        text: data.force,
        pointer: true,
        finger: {
            delay: 10
        }
    }, {
        highlights: highlights.concat(data.needHighlight ? data.needHighlight() : []),
        importantNodes
    });
};

TileGameTutorialHelper.createWaitStep = () => new TutorialStep({
    onStart: function () {
        cleverapps.focusManager.showControlsWhileFocused("opencards");
        cleverapps.tutorial.on("playCard", this.finish.bind(this), this);
    },
    onFinish: function () {}
});

TileGameTutorialHelper.isAvailable = function (tutorialName) {
    return Game.currentGame
        && Game.currentGame.levelWithTutorial()
        && Game.currentGame.level.content.tutorial === tutorialName
        && !Game.currentGame.shownTutorials.includes(tutorialName);
};